import axios from "axios";
import { capitalize } from "lodash";
import { getPathAPI, getAuthHeaders, triggerBlobDownload } from ".";

export async function downloadImportFileTemplate(
  collection: string
): Promise<void> {
  const response = await axios({
    url: `${getPathAPI()}/atlas-files/imports/templates`,
    method: "POST",
    responseType: "blob",
    data: { collection },
    headers: getAuthHeaders()
  });
  triggerBlobDownload(
    response.data,
    `${capitalize(collection)}ImportTemplate.csv`
  );
}
